import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var MptSvg = function MptSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.5 20.25a.75.75 0 0 1-.75.75H8v.75a.25.25 0 0 0 .25.25h13a.25.25 0 0 0 .25-.25v-18h.25V3.5l-1.5-1v1.75h.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.75 20.5h13a.25.25 0 0 0 .25-.25v-16H6.5v16a.25.25 0 0 0 .25.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    d: "M21.5 3.75v18a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25V21h11.75a.75.75 0 0 0 .75-.75v-16H20v16a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25v-16H6v16c0 .413.337.75.75.75h.75v.75c0 .413.337.75.75.75h13a.75.75 0 0 0 .75-.75v-18z",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31752F",
    d: "M20.293 1.5H6.5A.5.5 0 0 0 6 2v2.5h14.5v-.897a.25.25 0 0 1 .427-.177L22 4.5V3.207a.5.5 0 0 0-.146-.353l-1.207-1.207a.5.5 0 0 0-.354-.147"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C8C6C4",
    d: "M17.25 17.75H6.75v-9.5h10.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BBF8A",
    fillRule: "evenodd",
    d: "M8.25 10.5h8a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-8a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25m0 2h8a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-8a.25.25 0 0 0-.25.25v.5a.25.25 0 0 0 .25.25m6.5 1h2.75v1h-2.75a.25.25 0 0 1-.25-.25v-.5a.25.25 0 0 1 .25-.25m-2.25 3h3.25a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25H12.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31752F",
    d: "M3 18.5h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "M9.442 10.481Q8.884 10 7.834 10H5.5v6h1.145v-2.121H7.76q.67 0 1.18-.253.507-.254.785-.71.275-.456.275-1.042 0-.911-.558-1.393M7.63 12.963h-.985v-2.034h1.022q1.127 0 1.127.992 0 .51-.294.776t-.87.266",
    clipRule: "evenodd"
  }));
};
export var Mpt = function Mpt(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: MptSvg
  }));
};